import React from 'react';
import { useTranslation } from 'react-i18next';
import SearchCollaborator from './components/search-collaborator/index';
import DataListHead from '../../../../../../../../../../../../components/data-list/data-list-head/index';
import {upperCaseFirstLetter} from '../../../../../../../../../../../../utils';

const ListOfCollaboratorsHead = () => {
    const { t } = useTranslation();
    return (
	    <DataListHead>
            <div className="col-4">
                <SearchCollaborator/>
            </div>
            <div className="col-3 text-nowrap text-center">
                {upperCaseFirstLetter(t("popupSharingStatus"))}
            </div>
            <div className="col-1 text-nowrap text-center">
            {upperCaseFirstLetter(t("popupSharingMobileText"))}
            </div>
            <div className="col-3 text-nowrap">
                {upperCaseFirstLetter(t("popupSharingPermission"))}
            </div>
            <div className="col-1">
                &nbsp;
            </div>
	    </DataListHead>
    )
};

export default ListOfCollaboratorsHead;